/* =====================================================================
   COLDFRAME — 공통 스크립트 (cf-global.js)
   - 카페24 _onedesign/js/basic.js (CfxGridHeightSync)
   - 카페24 _component/main/section-script.html (메인 슬라이드) 이식
   - jQuery 없이 동작하며, 테마 편집기에서 섹션을 바꿔도 다시 초기화됩니다.
   ===================================================================== */
(function () {
  'use strict';

  /* -------------------------------------------------------------------
     같은 줄(행)에 있는 요소들의 높이를 가장 큰 값으로 맞춤 (카페24 동일)
     ------------------------------------------------------------------- */
  class CfxGridHeightSync {
    constructor(gridEl, itemSelector, colsPerRow) {
      this.grid = gridEl;
      this.itemSelector = itemSelector;
      this.colsPerRow = colsPerRow || 2;
      this.items = [];
      if (!this.grid) return;
      this.init();
    }

    init() {
      this.items = Array.from(this.grid.querySelectorAll(this.itemSelector));
      this.syncHeights();
    }

    syncHeights() {
      this.items.forEach((item) => {
        item.style.height = '';
      });
      const rows = this.chunkArray(this.items, this.colsPerRow);
      rows.forEach((row) => {
        const maxHeight = Math.max(...row.map((item) => item.offsetHeight));
        row.forEach((item) => {
          item.style.height = maxHeight + 'px';
        });
      });
    }

    chunkArray(arr, size) {
      const result = [];
      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    }
  }

  window.CfxGridHeightSync = CfxGridHeightSync;

  const hasSwiper = () => typeof window.Swiper === 'function';

  /* -------------------------------------------------------------------
     메인 상품 슬라이드 (m-product-new / m-product-pick)
     ------------------------------------------------------------------- */
  const MAIN_PRD_GROUP = 4;

  function createLpxEmptySlide() {
    const div = document.createElement('div');
    div.classList.add('swiper-slide', 'main-prd-item', 'lpx-empty');
    div.innerHTML = '<ul class="description unstyled-list"><li class="p-name"></li><li class="listSubname"></li></ul>';
    return div;
  }

  function syncMainPrdHeights(swEl) {
    const col = window.matchMedia('(min-width: 768px)').matches ? 4 : 2;
    new CfxGridHeightSync(swEl, '.description > .p-name', col);
    new CfxGridHeightSync(swEl, '.description li.listSubname', col);
  }

  function initMainPrdSwiper(swEl) {
    if (!hasSwiper() || swEl.swiper) return;

    const slideLen = swEl.querySelectorAll('.swiper-slide').length;
    if (!slideLen) return;

    const sdWrapper = swEl.querySelector('.swiper-wrapper');

    // loop fill (4개 단위로 빈 칸 채우기)
    const remainder = slideLen % MAIN_PRD_GROUP;
    if (remainder !== 0) {
      const needToAdd = MAIN_PRD_GROUP - remainder;
      for (let i = 0; i < needToAdd; i++) {
        sdWrapper.appendChild(createLpxEmptySlide());
      }
    }

    // loop additional (반복 재생에 필요한 개수 확보)
    const minRequired = MAIN_PRD_GROUP * 3;
    const slideCount = sdWrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    if (slideLen > MAIN_PRD_GROUP && slideLen < minRequired) {
      const originalSlides = Array.from(sdWrapper.querySelectorAll('.swiper-slide'));
      const timesToClone = Math.ceil(minRequired / slideCount);
      for (let i = 1; i < timesToClone; i++) {
        originalSlides.forEach((slide) => {
          sdWrapper.appendChild(slide.cloneNode(true));
        });
      }
    }

    // eslint-disable-next-line no-new
    new window.Swiper(swEl, {
      grid: {
        rows: 2,
        fill: 'row',
      },
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 16,
      loop: slideLen > MAIN_PRD_GROUP,
      navigation: {
        nextEl: swEl.querySelector('.swiper-button-next'),
        prevEl: swEl.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          grid: {
            rows: 1,
          },
          slidesPerView: 4,
          slidesPerGroup: 4,
          spaceBetween: 16,
        },
      },
      on: {
        init: function (swiper) {
          swiper.el.dispatchEvent(new Event('main-prd-init'));
        },
      },
    });
  }

  /* -------------------------------------------------------------------
     2단 배너 : 이미지 + 슬라이드 (banner-type4-slider)
     ------------------------------------------------------------------- */
  function initBnrSlider(box) {
    const bsBox = box.querySelector('.bni_sw');
    const swEl = box.querySelector('.main-bnr-swiper');
    if (!bsBox || !swEl || !hasSwiper() || swEl.swiper) return;

    const iSmallImages = bsBox.querySelectorAll('.c1 .xw');
    if (iSmallImages.length && !bsBox.querySelector('.c1 .xw.active')) {
      iSmallImages[0].classList.add('active');
    }

    const updateColPrd = (i) => {
      if (iSmallImages.length < 1) return;
      const idx = i % iSmallImages.length;
      if (iSmallImages[idx]) {
        iSmallImages.forEach((s) => s.classList.remove('active'));
        iSmallImages[idx].classList.add('active');
      }
    };

    const sdWrapper = swEl.querySelector('.swiper-wrapper');
    const mxSlides = sdWrapper.querySelectorAll('.swiper-slide');
    if (!mxSlides.length) return;
    mxSlides.forEach((sd, i) => {
      sd.dataset.idx = i;
    });

    // loop additional (4장 미만이면 복제) — 슬라이드가 1개면 넘기지 않고 고정
    const minRequired = 4;
    const slideCount = mxSlides.length;
    const single = slideCount < 2;
    if (!single && slideCount < minRequired) {
      const originalSlides = Array.from(mxSlides);
      const timesToClone = Math.ceil(minRequired / slideCount);
      for (let i = 1; i < timesToClone; i++) {
        originalSlides.forEach((slide) => {
          sdWrapper.appendChild(slide.cloneNode(true));
        });
      }
    }

    const swiper = new window.Swiper(swEl, {
      spaceBetween: 0,
      loop: !single,
      allowTouchMove: !single,
      navigation: single
        ? false
        : {
            nextEl: bsBox.querySelector('.swiper-button-next'),
            prevEl: bsBox.querySelector('.swiper-button-prev'),
          },
      on: {
        slideChangeTransitionStart: function (sw) {
          updateColPrd(sw.realIndex);
        },
      },
    });

    box.cfSlideTo = (index) => {
      if (single) {
        updateColPrd(0);
        return;
      }
      swiper.slideToLoop(index);
      updateColPrd(index);
    };
  }

  /* -------------------------------------------------------------------
     3단 그리드 (banner-type5-grid) — 모바일 슬라이드
     ------------------------------------------------------------------- */
  function initBnrGrid(box) {
    const swEl = box.querySelector('.main-bnr-swiper-t2');
    if (!swEl || !hasSwiper() || swEl.swiper) return;

    const swiper = new window.Swiper(swEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      // 카드가 한 줄 칸 수보다 적으면 가운데 정렬 (2026-11-02, RJC 카드 1장)
      centerInsufficientSlides: true,
      pagination: {
        el: box.querySelector('.bt_cardw .swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });

    box.cfSlideTo = (index) => swiper.slideTo(index);
  }

  /* -------------------------------------------------------------------
     초기화
     ------------------------------------------------------------------- */
  function initScope(scope) {
    const root = scope || document;

    const prdSwipers = root.querySelectorAll('.cf.main-wrapper .main-prd-swiper');
    prdSwipers.forEach(initMainPrdSwiper);

    root.querySelectorAll('[data-cf-bnr-slider]').forEach(initBnrSlider);
    root.querySelectorAll('[data-cf-bnr-grid]').forEach(initBnrGrid);

    // 상품명·요약 높이 맞추기 (카페24: DOMContentLoaded 시점)
    prdSwipers.forEach(syncMainPrdHeights);
  }

  function destroyScope(scope) {
    scope.querySelectorAll('.swiper').forEach((el) => {
      if (el.swiper) el.swiper.destroy(true, true);
    });
  }

  function start() {
    initScope(document);

    // 웹폰트가 늦게 적용된 경우 높이를 한 번 더 맞춤
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        document.querySelectorAll('.cf.main-wrapper .main-prd-swiper').forEach(syncMainPrdHeights);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // 테마 편집기
  document.addEventListener('shopify:section:load', (event) => {
    initScope(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyScope(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const box = event.target.closest('[data-cf-bnr-slider], [data-cf-bnr-grid]');
    if (!box || typeof box.cfSlideTo !== 'function') return;

    let index = -1;
    if (box.matches('[data-cf-bnr-slider]')) {
      index = Array.from(box.querySelectorAll('.c1 .xw')).indexOf(event.target);
    } else {
      index = Array.from(box.querySelectorAll('.c-item')).indexOf(event.target);
    }
    if (index >= 0) box.cfSlideTo(index);
  });
})();
